import React from 'react';
import Axios from 'axios';
import moment from 'moment';
import RateSysAdmin_nav from './RateSysAdmin_nav';

const ADMIN_LVL_MASTER = 0;				// same as Users.js

const cstTableHeaders = ['Rg Moy', 'Joueur', 'TRS', 'PJ', 'IPS', 'FP', '% VIC', 'DIFF', 'ERO', 'EC', 'TVP', 'Équipe'];


class RateSysAdminResults extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      playersByDivision: true,
      committeeVotes: true,
      elTrophyVotes: true,
      selectedDivIdx: 0,
      rateSysPlayersAll: [],
      rateSysPlayers: [],
      nbFormEntries: 0,
      loadingData: true
		};

    this.createTableHdrRow = this.createTableHdrRow.bind(this);
    this.dispPlayersTableRow = this.dispPlayersTableRow.bind(this);
    this.handleDivisionChange = this.handleDivisionChange.bind(this);
	}

  componentDidMount() {
		//console.log('RateSysAdminResults: componentDidMount');
    if (this.props.season._id !== undefined) {
      this.loadData()
    }
  }

  componentDidUpdate(prevProps) {
  	//console.log('RateSysAdminResults: componentDidUpdate')

  	if (!this.props.bRateSysExists) {
  		const path = './home';
			this.props.history.push(path);
		} 
    else if (prevProps.season._id.toString() !== this.props.season._id) {
      this.loadData()
    }
  }

  loadData() {
    var _this = this;
    var seasonId = this.props.season._id;

    //console.log('RateSysAdminResults - loadData');
    //console.log(seasonId)
    Axios.get('/api/ratesys/getRateSys/global/' + seasonId).then(function (responseRateSys) {

      //console.log("responseRateSys.data.players");
      //console.log(responseRateSys.data.players);

      var rateSys = responseRateSys.data;
      var playersByDivision = rateSys.playersByDivision;
      var committeeVotes = rateSys.committeeVotes;
      var elTrophyVotes = rateSys.elTrophyVotes;
      var rateSysPlayersAll = rateSys.players;

      _this.setState({
        playersByDivision: playersByDivision,
        committeeVotes: committeeVotes,
        elTrophyVotes: elTrophyVotes,
        rateSysPlayersAll: rateSysPlayersAll
      });

      // Load players (per division if needed)
      _this.loadPlayerResults(rateSysPlayersAll, playersByDivision, 0);
    });
  }

  loadPlayerResults(rateSysPlayersAll, playersByDivision, divIdx) {
    //console.log('loadPlayerResults');
    //console.log(divIdx);

    var _this = this;
    var season = this.props.season;
    var seasonId = this.props.season._id;

    // Get division name, if using divisions
    var division = season.subSeasons[0].divisions[divIdx].name; 
    if (!playersByDivision || (season.subSeasons[0].divisions.length <= 1)) {
      division = "ALL";
    }

    var URLdivision = encodeURIComponent(division.replace(/\./g, ' '));

    Axios.get('/api/ratesys/nbRespondents/seasonId/' + seasonId + '/division/' + URLdivision).then(function (responseNbResp) {

      var rateSysNbRespondents = responseNbResp.data.rateSysNbRespondents;
      var rateSysPlayers = rateSysPlayersAll;
      if (playersByDivision) {
        rateSysPlayers = rateSysPlayers.filter(rsp => (rsp.teamDiv === season.subSeasons[0].divisions[divIdx].name));
      }

      // Sort
      rateSysPlayers.sort((a, b) => a.calcAvgRankFilt - b.calcAvgRankFilt);

      // BgColor
      rateSysPlayers.forEach((rsp, rspIdx, rsps) => {
        if (rspIdx === 0) {
          rsp.bgcolor = false;
        } else {
          var ratingA = rsp.ratingStr.split('-')[0];
          var ratingB = rsps[rspIdx-1].ratingStr.split('-')[0];
          if (ratingA !== ratingB) {
            rsp.bgcolor = !rsps[rspIdx-1].bgcolor;
          } else {
            rsp.bgcolor = rsps[rspIdx-1].bgcolor;
          }
        }
      });

      _this.setState({
        selectedDivIdx: divIdx,
        rateSysPlayers: rateSysPlayers,
        nbFormEntries: rateSysNbRespondents,
        loadingData: false
      });
    });
  }

	render() {
		//console.log('RateSysAdminResults: render');
    //console.log(this.state);
    return (
      <div>

      <div className="row">
      <div className="col-md-12">
      	<h5>Système de cotation</h5>
      </div>
      </div>

    	<RateSysAdmin_nav adminAccess={this.props.adminAccess} season={this.props.season} bRateSysExists={this.props.bRateSysExists} />

      {!this.state.loadingData ? 
        this.showData() : null}

      </div>
	  );
  }

  showData() {
    return (
      <div>
      {this.showDivisionsSelector()}

      <div className="row">
      <div className="col-md-10 col-12">
        <h5>Résultats compilés</h5>
        <p>{this.state.nbFormEntries} formulaires soumis</p>

        {this.dispPlayersTable()}

      </div>
      </div>
      </div>
    )
  }

  showDivisionsSelector() {
    if (!this.state.playersByDivision) {
      return;
    }

    var divisions = this.props.season.subSeasons[0].divisions; 
     return (
      <div className="row row-margin-bottom-20">
      <div className="col-4">
        <h6>Cotation de joueurs par division</h6>
        <span>Choisir une division</span>
        <select className="form-control"
          value={this.state.selectedDivIdx} onChange={this.handleDivisionChange}>
          {divisions.map(this.dispDivOptions)}
        </select>
      </div>
      </div>
    );
  }

  dispDivOptions(div, divIdx, divisions) {
    return (
      <option value={divIdx} key={'div.'+ divIdx}>{div.name}</option>
    )
  }

  handleDivisionChange(e) {
    var selectedDivisionIdx = parseInt(e.target.value, 10);
    this.loadPlayerResults(this.state.rateSysPlayersAll, this.state.playersByDivision, selectedDivisionIdx)
  }

  dispPlayersTable() {
    var players = this.state.rateSysPlayers;
    return (
      <div className="row">
      <div className="col-12">

        <div className="table-responsive tableFixHeader tableFixHeaderRateSys resizeVerticalRateSys">
        <table className="table table-sm table-ratesysForm rateSysResultsTableHover tableFix2col">
          <thead><tr>
            {cstTableHeaders.map(this.createTableHdrRow)}
          </tr></thead>
          <tbody>
            {players.length !== 0 ?
              players.map(this.dispPlayersTableRow) : 
              <tr><td colSpan='99'> Aucun joueur </td></tr>
            }
          </tbody>
        </table>
        </div>

      </div>
      </div>
    )
  }

  createTableHdrRow(hdrItem, hdrIdx) {
    return (
      <th key={"colid." + hdrIdx}>{hdrItem}</th>
    )
  }

  dispPlayersTableRow(player, idx, players) {
    var classNameStr = "";
    if (player.bgcolor) {
      classNameStr = "rateSysResultsAltRow";
    }

    return (
      <tr className={classNameStr} key={"tr." + idx} id={"tr." + idx}>
        <td>{player.calcAvgRankFilt.toFixed(2)}</td>
        <td>{player.fn}</td>
        <td>{player.ratingStr}</td>
        <td>{player.stats.pj}</td>
        <td>{player.stats.ips}</td>
        <td>{player.stats.fp.toFixed(2)}</td>
        <td>{player.stats.pctWin.toFixed(1)}</td>
        <td>{player.stats.diff}</td>
        <td>{player.stats.ep}</td>
        <td>{player.stats.ec}</td>
        <td>{player.stats.tvp}</td>
        <td>{player.team}</td>
      </tr>
    )
  }

}

export default RateSysAdminResults;

